import debounce from 'debounce';
import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router';

import {selectApplication} from 'modules/applications/actions';
import {applicationBySlugSelector, selectedAppIdSelector, tokenStateSelector} from 'modules/applications/selectors';
import Loading from 'components/Controls/Loading';

const applicationContainerStyles = {
    width: '100%',
    margin: 0,
    padding: 0,
};

export default function Application() {
    const params = useParams();
    const app = useSelector(applicationBySlugSelector(params.application));
    const selectedAppId = useSelector(selectedAppIdSelector);
    const tokenIsSet = useSelector(tokenStateSelector);
    const dispatch = useDispatch();
    const debouncedSelectApplication = useCallback(
        debounce(id => dispatch(selectApplication(id)), 300),
        [dispatch]
    );

    // Only consider the app "ready to mount" when the URL slug, the
    // selected app in redux, and the token state are all ready
    const ready = !!(
        app && app.id && app.link && tokenIsSet && selectedAppId != null && selectedAppId == app.id
    );
    const scriptSrc = ready ? app.link : null;
    const containerId = ready ? `${app.slug}-container` : null;

    useEffect(() => {
        if (!scriptSrc || !containerId) {
            return undefined;
        }

        const script = document.createElement('script');
        script.src = scriptSrc;
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };

    }, [scriptSrc, containerId]);

    if (!params.application) {
        return <p>Error: no application selected</p>;
    }

    if (app && app.id && !selectedAppId) {
        // if the user has entered Uniportal on this component, we need to select the app to set the correct state
        debouncedSelectApplication(app.id);
    }

    if (!ready) {
        return <Loading text="Loading application..." />;
    }

    return <div id={containerId} style={applicationContainerStyles} />;
}